<template>
    <v-container fluid class="white--text important-links pa-0">
        <v-container>
            <v-row justify="space-between" dense >
                <v-col cols="6" sm="6"><strong><a :href="$t('footer.privacyPolicyPdf')" class="no-decoration white--text" target="_blank">{{ $t('footer.privacyPolicy') }}</a></strong> 
                    &nbsp;|&nbsp;
                    <strong><RouterLink class="no-decoration white--text" to="/ticket-validation">{{$t('footer.ticketValidation')}}</RouterLink></strong>
         <v-icon dark>
        mdi-verified
      </v-icon>
                </v-col>                                                   
                <v-col cols="6" sm="6" class="text-right">                    
                    <a href="https://www.botanickaliberec.cz" class="no-decoration white--text mr-2" target="_blank"><img style="vertical-align:middle" :src="require('../../assets/web.svg')" width="24" /></a>
                    <span class="mr-3"><a href="https://www.botanickaliberec.cz" class="no-decoration white--text" target="_blank">botanickaliberec.cz</a></span>
                    <a href="https://www.facebook.com/people/Botanick%C3%A1-zahrada-Liberec-LK/100089513884174/" class="no-decoration white--text" target="_blank">
                        <img style="vertical-align:middle" :src="require('../../assets/fb.svg')" width="24" /></a>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
    export default {
        name: 'ImportantLinks'
    }
</script>

<style lang="scss">
    .no-decoration {
        text-decoration: none;
    }
    .important-links {
        background-color: #ff9e00;
        font-size: 14px;
        h4 {
            font-weight: 600;
            text-transform: uppercase;
            font-size: 14px;
        }
    }
</style>
